module.exports = __webpack_public_path__ + "img/banner1.ff9f1ecd.png";